import React from 'react';
import useLayersStore from '../stores/layersStore';
import logo from '../assets/logo.svg';
import backgroundImage from '../assets/logo_bg.svg';

const ProgressBar = () => {
  const { isLoading, loadingProgress, branding } = useLayersStore();

  if (!isLoading) return null;

  return (
    <div
      className={`fixed top-0 left-0 0 w-full h-full text-center z-[1000] flex flex-col items-center justify-center gap-5`}
      style={{
        background:
          branding.primaryColor ||
          `linear-gradient(134deg, #ff4091 -25%, #4939de 35%, #fd60ff 135%)`,
      }}
    >
      <img src={branding.loadingLogo || logo} alt="logo" className="w-1/5" />
      <div className="text-white">{Math.round(loadingProgress)}%</div>
      <div className="w-3/5 h-1 rounded-lg overflow-hidden">
        <div
          className="h-full bg-white transition-[width] duration-100 ease-in-out"
          style={{ width: `${loadingProgress}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
